import { LINKS } from '@/shared/config/links';
import { planName } from '@/shared/config/plans';
import type { UseCheckoutFlowResult } from '../hooks/use-checkout-flow';
import { checkoutRows } from '../model/checkout-summary';
import type { WorkspaceData } from '../types';
import { PaddleFrame } from './paddle-frame';
import { SummaryList } from './summary-list';

type NewPlanCheckoutProps = { workspace: WorkspaceData; flow: UseCheckoutFlowResult };

/** A first paid plan: the summary and Paddle's inline checkout (design: Checkout, plans). */
export function NewPlanCheckout({ workspace, flow }: NewPlanCheckoutProps) {
  return (
    <>
      <SummaryList rows={checkoutRows(flow.plan)} />
      {flow.isPaymentsOff ? null : (
        <>
          <PaddleFrame
            phase={flow.phase}
            planName={planName(flow.plan)}
            email={workspace.billing.billingEmail}
            onSubscribe={() => void flow.subscribe()}
          />
          <p className="text-meta text-muted">
            Paddle.com is the merchant of record for this order and handles payment, tax and
            invoices. See our{' '}
            <a href={LINKS.TERMS} className="underline">
              Terms
            </a>{' '}
            and{' '}
            <a href={LINKS.REFUNDS} className="underline">
              Refund policy
            </a>
            . Cancel any month from Billing.
          </p>
        </>
      )}
    </>
  );
}
